<template>
  <TemplateView>
    <div class="container">
      <TemplatePageGrid
        :items="businessSegmentGrid"
        :page-data="pageData"
        :loading="loadingAnimation"
      >
        <template v-slot:buttons>
          <BusinessSegmentModal
            v-if="
              $userCheckAccess({
                abilities: 'edit_business_segments',
              })
            "
            :create="true"
          />
        </template>
        <BusinessSegmentTable :businessSegmentGrid="businessSegmentGrid" />
      </TemplatePageGrid>
    </div>
  </TemplateView>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import BusinessSegmentTable from 'components/setting/businessSegment/BusinessSegmentTable'
import BusinessSegmentModal from 'components/setting/businessSegment/BusinessSegmentModal'

export default {
  name: 'SettingBusinessSegment',
  components: {
    BusinessSegmentTable,
    BusinessSegmentModal,
  },
  data() {
    return {
      selected: 1,
    }
  },
  created() {
    this.downloadPageData()
  },
  watch: {
    '$route.query'() {
      this.downloadPageData()
    },
  },
  computed: {
    ...mapGetters('workBusinessSegment', ['businessSegmentGrid', 'pageData']),
    ...mapGetters(['loadingAnimation']),
  },
  methods: {
    ...mapActions('workBusinessSegment', ['onBusinessSegmentGrid']),
    downloadPageData() {
      let data = {
        limit: this.$route.query.limit,
        page: this.$route.query.page,
      }
      if (this.$route.query.sort_param && this.$route.query.sort_value) {
        data.sort = {
          param: this.$route.query.sort_param,
          value: this.$route.query.sort_value,
        }
      }
      if (this.$route.query.search) {
        data.search = this.$route.query.search
      }
      this.onBusinessSegmentGrid(data)
    },
  },
}
</script>
